import { gql } from '@apollo/client';

export const DATA_WAREHOUSE_IMPORT_CREATE = gql`
    mutation CreateDataWarehouseImport($input: CreateDataWarehouseImportInput!) {
        createDataWarehouseImport(input: $input) {
            id
            importType
            docType
            status
            metadata
            startedAt
            completedAt
            createdAt
            updatedAt
        }
    }
`;

export default DATA_WAREHOUSE_IMPORT_CREATE;
